import { mapState } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
import { localizeDate } from '@/utils/date';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'SettingsAnnouncementTable',
  mixins: [userItemsPerListMixin],
  props: {
    maintenance: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    },
    searchTerm: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      key: 'systemAnnouncements',
      deletePrompt: false,
      deleteAnnouncement: null,
      expandedItems: [],
      announcements: [],
      search: '',
      tableOptions: {
        ...defaultTableOptions
      },
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    ...mapState('app', ['color']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('Common.active'),
          value: 'active'
        }, {
          sortable: false,
          text: this.$i18n_t('accMgmt.announcement.announcement'),
          value: 'message'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.announcement.start'),
          value: 'start'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.announcement.end'),
          value: 'end'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.actions'),
          value: '',
          align: 'right'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    maintenance(list) {
      this.announcements = list;
    },
    searchTerm(term) {
      this.search = term;
    }
  },
  mounted() {
    this.announcements = this.maintenance;
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    clickedAnnouncementTableRow(item) {
      if (this.expandedItems.length === 0 || this.expandedItems[0].id !== item.id) {
        this.expandedItems = [item];
      } else {
        this.expandedItems = [];
      }
    },
    editAnnouncement(announcement) {
      this.$emit('openEditDialog', announcement);
    },
    doDeleteAnnouncement(announcement) {
      this.$emit('deleteAnnouncement', announcement);
    },
    localizeDate(item) {
      if (item) {
        return localizeDate(item);
      }
    },
    updatePagination(e) {
      if (e.page === parseInt(this.$route.query.page, 10) && e.itemsPerPage === parseInt(this.$route.query.perPage, 10)) {
        // If page or itemsPerPage didn't change, don't update the URL
        return;
      }
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    }
  }
};